import { lazy } from 'react';
import type { RouteObject } from 'react-router';

// Hand-written companions to the generated `routes.tsx` (which gives a /:id route to the inventory's *form* screens only).
// A custom screen that the API addresses by id needs one too: `GET /barcode/resolve` answers `/inv/item/{id}` for every
// `ASS-` label and bare serial, and the component-history rows link the same way. Keep this list minimal — a screen that
// belongs in the inventory belongs in routes.tsx, regenerated from the mockup by tools/mockup-extract.
const L = (p: () => Promise<{ default: React.ComponentType }>) => lazy(p);

export const extraRoutes: RouteObject[] = [
  { path: '/inv/item/:id', Component: L(() => import('../screens/inv/Item')) }, // stock item card by id (barcode resolve, history links)
  // WO-13 — the stock-count list. Spec §14 routes `/inv/counts[/{id}]`, but the mockup drew only the wizard, so the
  // screen contract has no `inv/counts` row and tools/mockup-extract cannot write it into routes.tsx.
  // The process flow home. Not a mockup screen — the mockup drew six departmental dashboards and no overview — so it
  // lives here rather than in the generated routes, and the index route renders it too.
  { path: '/flow', Component: L(() => import('../screens/Flow')) },
  // admin/themes — where a department builds its own look. Not a mockup screen; the mockup predates the theme engine.
  { path: '/admin/themes', Component: L(() => import('../screens/admin/Themes')) },

  // The Help section (ADR-017): the presentation, the tutorial and the documentation, inside the application so they
  // open on a server with no way out to the internet and wear whatever theme the department is wearing.
  { path: '/help', Component: L(() => import('../screens/help/Help')) },
  { path: '/help/presentation', Component: L(() => import('../screens/help/Presentation')) },
  { path: '/help/tutorial', Component: L(() => import('../screens/help/Tutorial')) },
  { path: '/help/documentation', Component: L(() => import('../screens/help/Documentation')) },

  { path: '/inv/counts', Component: L(() => import('../screens/inv/Counts')) },
  { path: '/inv/count/:id', Component: L(() => import('../screens/inv/Count')) }, // one count by id (the count sheets and the scan flow link this way)
  // WO-13 — PWA scan mode (spec §14 `/scan`). The mockup drew phone frames rather than desktop screens, so the screen
  // contract has one `inv/scan` row for the whole mode and tools/mockup-extract writes only the `/scan/*` catch-all into
  // routes.tsx. The six flows of spec §12 are hand-written here; being static segments they outrank that splat.
  { path: '/scan', Component: L(() => import('../screens/scan/Home')) },
  { path: '/scan/receive', Component: L(() => import('../screens/scan/Receive')) },
  { path: '/scan/issue', Component: L(() => import('../screens/scan/Issue')) },
  { path: '/scan/return', Component: L(() => import('../screens/scan/Return')) },
  { path: '/scan/transfer', Component: L(() => import('../screens/scan/Transfer')) },
  { path: '/scan/count', Component: L(() => import('../screens/scan/Count')) },
  { path: '/scan/lookup', Component: L(() => import('../screens/scan/Lookup')) },
];
